import '../scss/frontend.scss';
import { isInViewport } from './parts/helpers';
import Popup from './parts/popup-window';
import { popupsInit, initBlockVideo } from './parts/general';
import { initPostRelated } from './pages/single';
import { initFilterPosts, mobileFilterButton } from './pages/hub';
function setInputFocus() {
    const forms = document.querySelectorAll('form');
    if (forms.length === 0) {
        return;
    }
    forms.forEach((form) => {
        const inputs = form.querySelectorAll('input');
        const textarea = form.querySelectorAll('textarea');
        function addFocus(elements) {
            elements.forEach((el) => {
                el.addEventListener('focus', () => {
                    var _a;
                    (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('on-focus');
                });
                el.addEventListener('blur', () => {
                    var _a;
                    (_a = el.parentElement) === null || _a === void 0 ? void 0 : _a.classList.remove('on-focus');
                });
            });
        }
        addFocus(inputs);
        addFocus(textarea);
    });
}
function downloadPDF() {
    const links = document.querySelectorAll('a[href$=".pdf" i]');
    links.forEach((link) => {
        link.setAttribute('download', '');
    });
}
function ready() {
    const popupInstance = new Popup();
    const header = document.querySelector('.site-header');
    const navigation = document.querySelector('.block-navigation');
    const BlockAnimation = document.querySelectorAll('.js-block-animation');
    const UnderlineTitles = document.querySelectorAll('.js-underline-title');
    const ZoomIn = document.querySelectorAll('.js-zoom-in');
    const FadeIn = document.querySelectorAll('.js-fade-in');
    const FadeInRight = document.querySelectorAll('.js-fade-in-right');
    const FadeInLeft = document.querySelectorAll('.js-fade-in-left');
    function checkInView() {
        [...BlockAnimation].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animate__animated', 'animate__fadeInUp');
            }
        });
        [...UnderlineTitles].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('inview');
            }
        });
        [...ZoomIn].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animate__animated', 'animate__zoomIn');
            }
        });
        [...FadeIn].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animate__animated', 'animate__fadeIn');
            }
        });
        [...FadeInRight].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animate__animated', 'animate__fadeInRight');
            }
        });
        [...FadeInLeft].forEach((item) => {
            if (isInViewport(item)) {
                item.classList.add('animate__animated', 'animate__fadeInLeft');
            }
        });
    }
    setInputFocus();
    initPostRelated();
    downloadPDF();
    initBlockVideo();
    initFilterPosts('.js-archive-post_roles');
    initFilterPosts('.js-archive-post_themes');
    initFilterPosts('.js-archive-post_types');
    mobileFilterButton('.js-archive-filters-icon');
    popupInstance.init();
    popupsInit();
    const subMenus = header.querySelectorAll('.sub-menu');
    subMenus.forEach((submenu) => {
        if (submenu.querySelector('.sub-menu')) {
            submenu.classList.add('sub-menu--large');
        }
    });
    window.onload = function () {
        document.body.className += ' loaded';
    };
    var lastScrollTop = 66;
    window.document.addEventListener('scroll', () => {
        const st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            header.classList.add('scroll-header');
            if (navigation) {
                navigation.classList.add('is-scroll-header');
            }
        }
        else if (st < lastScrollTop) {
            header.classList.remove('scroll-header');
            if (navigation) {
                navigation.classList.remove('is-scroll-header');
            }
        }
        lastScrollTop = st <= 0 ? 0 : st;
        checkInView();
    });
    {
        const operationHeader = header && Math.floor(window.scrollY) > 100 ? 'add' : 'remove';
        header.classList[operationHeader]('scroll-header');
        checkInView();
    }
}
window.document.addEventListener('DOMContentLoaded', ready);
